import { connect } from 'react-redux'
import React from 'react'
import { CLI_MULTICINEMA_MODE, ROUTES_DATA, TRANSLATION } from '../../constants/state'
import toJS from './toJS'
import getData from '../../functions/getData'
import { MASTERMULTICINEMA } from '../../constants/multiCinemaModes'

const mapStateToProps = (state, ownProps) => ({
    routeMovie: state.getIn([ROUTES_DATA, 'movies', 'items', ownProps.movieId]),
    currentLang: state.getIn([TRANSLATION, 'currentLang']),
    multicinemaMode: getData(state, CLI_MULTICINEMA_MODE)
})

const MovieURL = ({movieId, routeMovie, multicinemaMode, currentLang}) => (
    <div className="movie-information-item">
        <span className="movie-information-item-name text-small-light">URL: </span>

        {(
            MASTERMULTICINEMA === multicinemaMode || 
            !routeMovie || 
            !routeMovie.hasOwnProperty('uri_list') || 
            !routeMovie.uri_list.hasOwnProperty(currentLang) || 
            !routeMovie.uri_list[currentLang]
        ) ? (
            <span className="movie-information-item-value text-small-regular">{"Standort-Programmübersicht-URL + /?id=" + movieId}</span>
        ) : (
            <a className="movie-information-item-value text-small-regular" href={routeMovie.uri_list[currentLang]}  target="_blank">{routeMovie.uri_list[currentLang]}</a>
        )}
        
    </div>
)

export default connect(mapStateToProps, null)(toJS(MovieURL))